/* eslint-disable import/no-cycle */
import React from 'react';
import { navigate } from '@gatsbyjs/reach-router/'; // @ts-ignore
import { globalizationPath } from '@rcg/ui-react';
import Routes from './Routes';

import {
  NAVIGATION_PATHS,
  ROOT_PATH,
  BOOKING_ID_URL,
  URL_SOURCE_APP,
  COOKIE_KEYS,
  REDIRECT_API_URL,
  TOKEN,
} from './commons/constants';
import {
  getUrlData,
  setSessionStorageItem,
  safeEncode,
  getCookies,
  getSessionStorageItem,
} from './commons/utils';

const routeUser = ({ isLoggedIn }, GLOBALS, ldFlags, state) => {
  const enableRedirect = ldFlags ? ldFlags['is-unified-manage-redirection-enabled'] : null;

  const currentToken = state?.state?.booking?.token;
  const bookingIdParam = getUrlData(BOOKING_ID_URL);
  const sourceExternalData = getUrlData(URL_SOURCE_APP);
  const isGuestLogged = getCookies(COOKIE_KEYS.ACCESS_TOKEN);
  // eslint-disable-next-line eqeqeq
  const isRetrieveBooking = getSessionStorageItem('retrieve');
  sessionStorage.setItem(URL_SOURCE_APP, sourceExternalData);
  setSessionStorageItem(BOOKING_ID_URL, bookingIdParam);
  let urlPath = '';
  if (GLOBALS) {
    const navPath =
      NAVIGATION_PATHS.find((path) => window.location.pathname.includes(path.login)) ||
      NAVIGATION_PATHS.find((path) => path.default);

    const { market, lang } = GLOBALS.data;
    urlPath = globalizationPath(market, lang, ROOT_PATH);
    const bookingToken = getUrlData(TOKEN);
    setSessionStorageItem('main-token', bookingToken);
    if (isGuestLogged && bookingToken && !isRetrieveBooking) {
      sessionStorage.setItem(URL_SOURCE_APP, 'ga');
      navigate(`${urlPath}/${navPath.login}`);
    }

    if (isLoggedIn && (state || !window.location.pathname.startsWith(urlPath))) {
      if (enableRedirect) {
        const encoded = currentToken && safeEncode(currentToken);
        window.location.replace(`${REDIRECT_API_URL}${encoded}`);
        return;
      }
      navigate(`${urlPath}/${navPath.dashboard}`, state);
    } else if (!isLoggedIn && !bookingIdParam) {
      navigate(`${urlPath}/${navPath.login}`);
    }
  }

  // eslint-disable-next-line consistent-return
  return <Routes urlPath={urlPath} />;
};

export default routeUser;
